module.exports = __webpack_public_path__ + "static/media/15.85ae85b5.svg";